import { Link } from 'react-router-dom';
import { categories } from '@/mocks/manga';

export default function CategoryNav() {
  return (
    <section className="w-full bg-background-50 py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">漫画分类</h2>
          <p className="text-sm text-foreground-500 mt-2">海量漫画，按分类轻松找到你想看的</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 rounded-xl bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 group-hover:bg-primary-200 transition-colors">
                <i className={`${cat.icon} text-xl text-primary-600`}></i>
              </div>
              <span className="text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400">{cat.count.toLocaleString()} 部</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}